<template>
  <PostListVirtual
    :fetchNext="fetchNext"
    :noPostsIconLink="getAbsoluteAssetLink('nami/stickers/sad.png')"
    noPostsMessage="No one has posted yet."
    ref="feedList"
  />
</template>

<script setup lang="ts">
import { Post, type PostListParams } from "~/src/api";

const nuxtApp = useNuxtApp();
const authStore = nuxtApp.$auth();

async function fetchNext(params: PostListParams) {
  const token = (await authStore?.getToken()) ?? undefined;
  return await Post.getPosts(params, token);
}

const feedList = ref();
const props = defineProps<{ toggleRefresh: boolean }>();
const ignoreRefresh = ref(true);

onActivated(() => {
  ignoreRefresh.value = false;
  feedList.value?.checkForNewPosts();
});

onDeactivated(() => {
  ignoreRefresh.value = true;
});

watch(
  () => props.toggleRefresh,
  () => {
    if (ignoreRefresh.value) return;
    feedList.value?.refreshAllPosts();
  },
);

const checkForPosts = () => feedList.value?.checkForNewPosts();

onMounted(() => {
  window.addEventListener("focus", checkForPosts);
});
onBeforeUnmount(() => {
  window.removeEventListener("focus", checkForPosts);
});
</script>
